// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__35cy4","col":"CardReaderDesc_col__1j6VQ","label":"CardReaderDesc_label__orA2t"};